import type { Ceviri } from "../tip";
import type { ortak as tr } from "../tr/ortak";

/** English dictionary · ortak. */
export const ortak: Ceviri<typeof tr> = {
  kaydet: "Save",
  kaydediliyor: "Saving…",
  iptal: "Cancel",
  vazgec: "Cancel",
  sil: "Delete",
  siliniyor: "Deleting…",
  kapat: "Close",
  duzenle: "Edit",
  ekle: "Add",
  evet: "Yes",
  hayir: "No",
  tamam: "OK",
  devam: "Continue",
  geri: "Back",
  yukleniyor: "Loading…",
  okunuyor: "Reading…",
  yenidenDene: "Try again",
  secin: "Select…",
  tumu: "All",
  ayrinti: "Details",
  teknikAyrinti: "Technical details",
  bilinmiyor: "unknown",
  gun: (n) => `${n} ${n === 1 ? "day" : "days"}`,
  kurKiyasAdi: { USD: "Dollar / TRY", EUR: "Euro / TRY" },
};
